import { Component, OnInit, AfterViewInit, AfterViewChecked } from '@angular/core';
import { AuthService } from '../auth.service';
import { AppCommonService } from '../appcommon.service';
import { BlogService } from '../blogs/blog.service';
import { IBlog } from '../blogs/blog';
import { ActivatedRoute, Router } from '@angular/router';
import { Meta } from '@angular/platform-browser';
import { LoaderService } from '../LoaderService';
import { ILoggedUser, LoggedUserModel, TokenModel, LoggedUser } from '../headerandnavigation/loggeduser/loggeduser';
import { HeaderAndNavigationService } from '../headerandnavigation/headerandnavigation.service';
import { Observable } from 'rxjs';
import { ApiEndPoints } from '../api.endpoints';
import { RequestOptions } from '@angular/http';
declare var $: any;

@Component({
    templateUrl: './welcome.component.html'
})
export class WelcomeComponent implements OnInit, AfterViewInit {
    public pageTitle: string = 'Welcome';
    p: number = 1;
    blogsList: IBlog[];
    private sub: any;
    //public showHoldingPage: boolean = false;
    constructor(private authService: AuthService,
        public blogService: BlogService,
        private router: Router,
        private meta: Meta,
        private appCommonService: AppCommonService,
        private loaderService: LoaderService,
        public headerAndNavigationService: HeaderAndNavigationService,
        private route: ActivatedRoute
    ) {
        this.meta.updateTag({ name: 'title', content: this.appCommonService.pageName });
    }

    ngOnInit() {
        this.appCommonService.pageContentAdditionalClass = "home-page login-page";
        this.loadBlogsList();
        window.scrollTo(0, 0);
        $('#logout').hide();

        //if (this.router.url === '/testarea') {
        //  this.showHoldingPage = false;
        //  this.appCommonService.showLogoleft();
        //}
        //else {
        //  this.appCommonService.hideContact();
        //  this.appCommonService.hideLogin();
        //  this.appCommonService.showLogoCenter();
        //}    
    }


    ngAfterViewInit() {
        this.appCommonService.loadRequiredJS();
        //if (this.authService.checkShowWelcomeMessage()) {
        //  $('#welcomeModal').modal('show');
        //}

        $('.tabs-left li a').click(function () {
            $(this).parent().siblings().removeClass("active");
        });

        $('.tabs-left li a').hover(function () {
            $(this).trigger('click');
        });

        const selfMe = this;
        $('#welcomeModal').on('hidden.bs.modal', function () {
            selfMe.closeWelcomeWindow();
        });

        $('#homepage_video').on('show.bs.modal', function (e) {
            $("#video_homepage_video").attr('src', "https://www.youtube.com/embed/kNyQAEs_1QM?rel=0&amp;showinfo=0&amp;modestbranding=1&amp;autoplay=1");
        });
        $('#homepage_video').on('hide.bs.modal', function (e) {
            $("#video_homepage_video").attr('src', "https://www.youtube.com/embed/kNyQAEs_1QM");
        });

        $('#fuel_card_account').on('show.bs.modal', function (e) {
            $("#video_fuel_card_account").attr('src', "https://www.youtube.com/embed/dYgCeuTX-q4?rel=0&amp;showinfo=0&amp;modestbranding=1&amp;autoplay=1");
        });
        $('#fuel_card_account').on('hide.bs.modal', function (e) {
            $("#video_fuel_card_account").attr('src', "https://www.youtube.com/embed/dYgCeuTX-q4");
        });

        $('#business_advantage').on('show.bs.modal', function (e) {
            $("#video_business_advantage").attr('src', "https://www.youtube.com/embed/9y0iTMeBqJQ?rel=0&amp;showinfo=0&amp;modestbranding=1&amp;autoplay=1");
        });
        $('#business_advantage').on('hide.bs.modal', function (e) {
            $("#video_business_advantage").attr('src', "https://www.youtube.com/embed/9y0iTMeBqJQ");
        });

        $('#drivers_club').on('show.bs.modal', function (e) {
            $("#video_drivers_club").attr('src', "https://www.youtube.com/embed/FvrX9dfoJUI?rel=0&amp;showinfo=0&amp;modestbranding=1&amp;autoplay=1");
        });
        $('#drivers_club').on('hide.bs.modal', function (e) {
            $("#video_drivers_club").attr('src', "https://www.youtube.com/embed/FvrX9dfoJUI");
        });

        $('#fleet_solutions').on('show.bs.modal', function (e) {
            $("#video_fleet_solutions").attr('src', "https://www.youtube.com/embed/r_yrwkUoiLE?rel=0&amp;showinfo=0&amp;modestbranding=1&amp;autoplay=1");
        });
        $('#fleet_solutions').on('hide.bs.modal', function (e) {
            $("#video_fleet_solutions").attr('src', "https://www.youtube.com/embed/r_yrwkUoiLE");
        });

        $('#MyServiceExpert').on('show.bs.modal', function (e) {
            $("#MyServiceExpert_video").attr('src', "https://www.youtube.com/embed/9dsVAFMWCeg?rel=0&amp;showinfo=0&amp;modestbranding=1&amp;autoplay=1");
        });
        $('#MyServiceExpert').on('hide.bs.modal', function (e) {
            $("#MyServiceExpert_video").attr('src', "https://www.youtube.com/embed/9dsVAFMWCeg");
        });

        $('#TeleGence').on('show.bs.modal', function (e) {
            $("#TeleGence_video").attr('src', "https://www.youtube.com/embed/rTAVH3DxG4o?rel=0&amp;showinfo=0&amp;modestbranding=1&amp;autoplay=1");
        });
        $('#TeleGence').on('hide.bs.modal', function (e) {
            $("#TeleGence_video").attr('src', "https://www.youtube.com/embed/rTAVH3DxG4o");
        });

        $('#MyDriveSafe').on('show.bs.modal', function (e) {
            $("#MyDriveSafe_video").attr('src', "https://www.youtube.com/embed/eFH7wqpCljc?rel=0&amp;showinfo=0&amp;modestbranding=1&amp;autoplay=1");
        });
        $('#MyDriveSafe').on('hide.bs.modal', function (e) {
            $("#MyDriveSafe_video").attr('src', "https://www.youtube.com/embed/eFH7wqpCljc");
        });

        $('#MileageCount').on('show.bs.modal', function (e) {
            $("#MileageCount_video").attr('src', "https://www.youtube.com/embed/thmkZ5PJwgI?rel=0&amp;showinfo=0&amp;modestbranding=1&amp;autoplay=1");
        });
        $('#MileageCount').on('hide.bs.modal', function (e) {
            $("#MileageCount_video").attr('src', "https://www.youtube.com/embed/thmkZ5PJwgI");
        });

        $('#CardProtect').on('show.bs.modal', function (e) {
            $("#CardProtect_video").attr('src', "https://www.youtube.com/embed/8HCeEJHD4v0?rel=0&amp;showinfo=0&amp;modestbranding=1&amp;autoplay=1");
        });
        $('#CardProtect').on('hide.bs.modal', function (e) {
            $("#CardProtect_video").attr('src', "https://www.youtube.com/embed/8HCeEJHD4v0");
        });

        $('.homepageslider').slick({
            dots: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 5000,
            touchMove: true
        });

        selfMe.identityProcess();

        $(".verticalslider").slick({
            dots: false,
            infinite: false,
            slidesToShow: 6,
            slidesToScroll: 6,
            vertical: true,
            verticalSwiping: true,
            responsive: [
                {
                    breakpoint: 1400,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 5
                    }
                },
                {
                    breakpoint: 1140,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        vertical: false,
                        verticalSwiping: false
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                        vertical: false,
                        verticalSwiping: false
                    }
                },
                {
                    breakpoint: 769,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        vertical: false,
                        verticalSwiping: false
                    }
                },
                {
                    breakpoint: 581,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        vertical: false,
                        verticalSwiping: false
                    }
                },
                {
                    breakpoint: 376,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        vertical: false,
                        verticalSwiping: false
                    }
                }
            ]
        });

        this.route.fragment.subscribe((fragment: string) => {
            var Id = this.GetId(fragment);
            if (fragment != null && !fragment.includes("id_token")) {
                $("#p" + fragment).trigger('click');
                $('.verticalslider').slick('slickGoTo', Id);
            }
            //var Id = this.GetId(fragment);

            //$("#p" + fragment).trigger('click');


            //$('.verticalslider').slick('slickGoTo', Id);
        })
    }



    identityProcess() {

        if (typeof location !== "undefined" && window.location.hash) {
            setTimeout(() => {
                let isAuthorized = sessionStorage.getItem(("_isAuthorized_" + this.authService.clientId));

                if (!isAuthorized) {
                    window.location.reload();
                }
                if (isAuthorized) {
                    this.loaderService.display(true);

                    //this.headerAndNavigationService.ClearUserData();
                    this.initialLoadCalls();
                }
            }, 2500);

        }
        else {
            let userData = JSON.parse(sessionStorage.getItem(("userData_" + this.authService.clientId)));
            if (userData == "" || userData === null) {
                setTimeout(() => {
                    //this.login();
                }, 2500);
            }
        }
    }



    initialLoadCalls() {

        let userData = JSON.parse(sessionStorage.getItem(("userData_" + this.authService.clientId)));
        //debugger;
        if (userData == undefined || userData == null || userData == {} || userData=="") {
            setTimeout(() => {
                this.initialLoadCalls();
            }, 1000);
        }
        else
        {
        
        let userId = userData.sub;
        let impId = localStorage.getItem(this.authService.mftImpersonationId)
        if (impId !== "" && impId !== null) {
            userId = impId;
        }

        if (impId != undefined && impId != null) {

            this.headerAndNavigationService.callImperaonateAuthenticateToken(this.authService.getUserToken(), impId)
                .subscribe(
                    (token: any) => {
                        //debugger
                        this.headerAndNavigationService.updateUserInfoXRM(token._body)
                            .subscribe(
                                (data: any) => {
                                    sessionStorage.setItem("userData_" + this.authService.clientId, data._body);
                                    // console.log("updateUserInfoXRM", data._body)
                                },
                                (error: any) => {

                                }
                            );
                    },
                    (error: any) => {

                    }
                );
        }
        this.authService.getIdentityLoggedUserFromAPI(userId)
            .subscribe(
                (user: ILoggedUser) => {

                    user.applications_access = userData.applications_access;
                    this.authService.setUser(user);
                    this.authService.setUserRoles(user);
                    let tokenModel: TokenModel = new TokenModel();
                    tokenModel.access_token = this.authService.getUserToken()
                    tokenModel.token_type = "bearer";
                    tokenModel.expires_in = 3600;
                    tokenModel.userName = "";
                    console.log(user);
                    tokenModel.userId = user.id;
                    tokenModel.companyId = user.companyId;
                    tokenModel.allowOrderNotes = user.allowOrderNotes;
                    tokenModel.allowAlternateDeliveryAddress = user.allowAlternateDeliveryAddress;
                    this.authService.saveToken(tokenModel);
                    localStorage.setItem("mftAccessTokenLocalstorage", JSON.stringify(tokenModel));
                    this.loaderService.display(false);
                    this.redirectToRelevantAccessArea();
                },
                (error: any) => {
                    //debugger
                    let loggedUser: LoggedUser = new LoggedUser();
                    loggedUser.applications_access = userData.applications_access;
                    loggedUser.name = userData.name;
                    loggedUser.email = userData.email;
                    loggedUser.telephone = userData.phone_number;
                    this.authService.setUser(loggedUser);
                    if (userData != undefined || userData != null) {
                        this.loaderService.display(false);
                        this.redirectToRelevantAccessArea();
                        let tokenModel: TokenModel = new TokenModel();
                        tokenModel.access_token = this.authService.getUserToken()
                        tokenModel.token_type = "bearer";
                        tokenModel.expires_in = 3600;
                        tokenModel.userName = "";
                        //console.log(user);
                        //tokenModel.userId = user.id;
                        //tokenModel.companyId = user.companyId;
                        //tokenModel.allowOrderNotes = user.allowOrderNotes;
                        //tokenModel.allowAlternateDeliveryAddress = user.allowAlternateDeliveryAddress;
                        this.authService.saveToken(tokenModel);
                        localStorage.setItem("mftAccessTokenLocalstorage", JSON.stringify(tokenModel));
                    }
                    else {
                        this.headerAndNavigationService.showError("Logged user retrieval problem", <any>error);
                        this.headerAndNavigationService.ClearUserData();
                        this.router.navigate(['/noaccess']);
                        this.loaderService.display(false);
                    }
                }
            );
        }
    }

    redirectToRelevantAccessArea(): void {
        if (this.appCommonService.reDirectURL === '/login') {
            this.appCommonService.reDirectURL = '/home';
        }
        this.router.navigate([this.appCommonService.reDirectURL]);
    }

    onWelcomeLoginClick(event): void {
        event.stopPropagation();
        this.appCommonService.loginMenuManualClick();
    }

    closeWelcomeWindow() {
        $('#welcomeModal').modal('hide');
        this.authService.setShowWelcomeMessage();
    }

    loadBlogsList() {

        this.blogService.getBlogsList()
            .subscribe(
                (blogs: IBlog[]) => {
                    // console.log(blogs);
                    this.blogsList = blogs;
                },
                (error: any) => {
                    this.blogService.showError("Blog retrieval problem", <any>error)
                }
            );
    }

    public login() {
        this.authService.login();
    }


    GetId(fragment: string) {

        let val = 0;
        switch (fragment) {
            case "p21":
                val = 0;
                break;
            case "p22":
                val = 1;
                break;
            case "p23":
                val = 2;
                break;
            case "p24":
                val = 3;
                break;
            case "p25":
                val = 4;
                break;
            case "p26":
                val = 5;
                break;
            case "p27":
                val = 6;
                break;
            case "p28":
                val = 7;
                break;
            case "p29":
                val = 8;
                break;

            default:
                val = 0;
                break;

        }
        return val;

    }

    InitializeSlick() {

        return $(".verticalslider").slick({
            dots: false,
            infinite: false,
            slidesToShow: 5,
            slidesToScroll: 5,
            vertical: true,
            verticalSwiping: true,
            responsive: [
                {
                    breakpoint: 1580,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4
                    }
                },
                {
                    breakpoint: 881,
                    settings: {
                        vertical: false,
                        verticalSwiping: false
                    }
                },
                {
                    breakpoint: 769,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        vertical: false,
                        verticalSwiping: false
                    }
                },
                {
                    breakpoint: 581,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        vertical: false,
                        verticalSwiping: false
                    }
                },
                {
                    breakpoint: 376,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        vertical: false,
                        verticalSwiping: false
                    }
                }
            ]
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/welcome/welcome.component.ts